<div class="d-flex full-height" style="overflow-y: hidden">
    <div class="flex-grow-1 full-height" style="position: relative; min-width: 0">
        <div
            id="ticket-details-container-for-scroll"
            class="flex-grow-1"
            [ngClass]="{
                'bulk-operation-margin': ticket.selectedRepliesCount() > 0,
            }">
            <div
                [ngClass]="{
                    'ticket-details-chat': ticketViewType === ticketViewEnum.chat,
                    'one-time': commonDataService.isOneTime,
                }"
                id="thread-container">
                <div class="ticket-header" id="print-section">
                    <div class="d-flex justify-content-between position-relative">
                        <app-importance [ticket]="ticket" [importance]="ticket.importance"></app-importance>
                        <div class="text-break">
                            @if (ticket.parent?.ticketId) {
                                <h4 class="d-inline-block">
                                    <a
                                        [routerLink]="[]"
                                        [queryParams]="{ ticketId: ticket.parent.ticketId }"
                                        placement="bottom"
                                        tooltip="{{ 'Parent ticket' | translate }}"
                                        [adaptivePosition]="false"
                                        class="flex-grow-1 truncate pe-2">
                                        #{{ ticket.parent.ticketId }}</a
                                    ><span>&nbsp;>&nbsp;</span>
                                </h4>
                            }
                            <h4
                                class="d-inline-block me-3 pointer"
                                ngxClipboard
                                [cbContent]="ticket.id?.toString()"
                                placement="bottom"
                                [tooltip]="copyTicketIdTooltip"
                                [adaptivePosition]="false"
                                #ticketIdTooltip="bs-tooltip"
                                (click)="updateCopyTicketIdTooltip(ticketIdTooltip)">
                                #{{ ticket.id }}
                            </h4>

                            @if (!ticket.permalink) {
                                &nbsp;{{ ticket.detailedSource | detailedTicketSource: ticket.isAdTicket }}
                                @if (ticket.sourceName) {
                                    <span>&nbsp;<span style="font-size: 9px">▶</span> {{ ticket.sourceName }}</span>
                                }
                                @if (ticket.replyCount) {
                                    <span>&nbsp;({{ ticket.replyCount }})</span>
                                }
                            } @else {
                                <a [href]="ticket.permalink" target="_blank" class="pointer text-md"
                                    >&nbsp;{{ ticket.detailedSource | detailedTicketSource: ticket.isAdTicket }}
                                    @if (ticket.sourceName) {
                                        <span
                                            >&nbsp;<span style="font-size: 9px">▶</span> {{ ticket.sourceName }}</span
                                        >
                                    }
                                    @if (ticket.replyCount) {
                                        <span>&nbsp;({{ ticket.replyCount }})</span>
                                    }
                                </a>
                            }
                        </div>
                        @if (isOpenTicketInNewWindowVisible() && !commonDataService.isOneTime && !isSingleTicketView) {
                            <button
                                class="btn btn-icon"
                                data-testid="inbox-ui-ticket-header-open-ticket-in-new-window"
                                (click)="openTicketInNewWindowService.openTicketInNewWindow(ticket.id)"
                                [tooltip]="'In new window' | translate"
                                placement="bottom">
                                <sb-inline-svg
                                    class="icon external-link-icon"
                                    aria-label="My icon"
                                    [url]="'/sb-tools/theme/images/icons/external-link-icon.svg'">
                                </sb-inline-svg>
                            </button>
                        }
                        @if (isSingleTicketView && isInIframe) {
                            <button
                                type="button"
                                class="btn btn-icon"
                                (click)="back()"
                                [tooltip]="'Back' | translate"
                                placement="bottom">
                                <sb-inline-svg
                                    class="icon external-link-icon"
                                    aria-label="My icon"
                                    [url]="'/assets/images/back-icon.svg'">
                                </sb-inline-svg>
                            </button>
                        }
                    </div>

                    <app-ticket-title [isFormEmailApi]="isFormEmailApi" [ticket]="ticket"></app-ticket-title>

                    <form class="d-flex flex-row align-items-center flex-wrap">
                        @if (isTicketHeaderVisible('ticketType')) {
                            <div
                                class="select-container sentiment-selector me-2"
                                data-testid="inbox-ui-ticket-header-ticket-type">
                                <ng-select
                                    [searchable]="false"
                                    [clearable]="false"
                                    class="sentiment"
                                    [(ngModel)]="ticket.sentiment"
                                    id="sentiment"
                                    name="sentiment"
                                    (ngModelChange)="updateSentiment()"
                                    [disabled]="
                                        commonDataService.isOneTime ||
                                        assignService.isNotAssignedToCurrentUser ||
                                        commonDataService.user.isReadOnly
                                    ">
                                    @for (sentiment of sentimentsEnum | enumToArray; track sentiment) {
                                        <ng-option [value]="sentiment">
                                            {{ sentiment | sentiment }}
                                        </ng-option>
                                    }
                                </ng-select>
                            </div>
                        }

                        @if (isTicketHeaderVisible('category')) {
                            <app-category-selector
                                data-testid="inbox-ui-ticket-header-category"
                                [ticket]="ticket"
                                (ticketStatusUpdated)="handleTicketStatusUpdated($event)"
                                (updateTagsEvent)="loadTagsByCategory($event)"
                                (needToAddTagsToCloseTicketEvent)="openAddTagsModalForClosingTicket($event)">
                            </app-category-selector>
                        }

                        @if (isTicketHeaderVisible('tag') && ticket.tags?.length) {
                            <app-tags [ticketId]="ticket.id" [tags]="ticket.tags"></app-tags>
                        }

                        @if (
                            isTicketHeaderVisible('tag') &&
                            !commonDataService.isOneTime &&
                            !commonDataService.user.isReadOnly
                        ) {
                            <span
                                class="label label-tags label-sm mb-1 mt-1"
                                data-testid="inbox-ui-ticket-header-tag"
                                (click)="openAddTagsModal()"
                                [ngClass]="{ disabled: isUpdatingTagsList }">
                                <sb-inline-svg
                                    class="icon"
                                    [url]="
                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Tag icon.svg'
                                    "></sb-inline-svg>
                                {{ 'Tags' | translate }}
                            </span>
                        }
                    </form>

                    @if (isSessionAuthenticationVisible) {
                        @let ticketAuthenticationLevel = ticket.sessionAuthentication.level;
                        <section
                            class="authentication-level-card"
                            data-testid="inbox-ui-ticket-header-authentication-level">
                            <div
                                class="authentication-level-card__section"
                                data-testid="inbox-ui-ticket-header-authentication-level-section">
                                <h5 data-testid="inbox-ui-ticket-header-authentication-level-label">
                                    {{ 'Authentication level' | translate }}
                                </h5>
                                <span
                                    data-testid="inbox-ui-ticket-header-authentication-level-badge"
                                    class="authentication-level-badge authentication-level-{{
                                        ticketAuthenticationLevel
                                    }}">
                                    {{ formatAuthenticationLevel(ticketAuthenticationLevel) }}
                                </span>
                            </div>

                            @if (isSessionAuthenticationRequestSectionVisible) {
                                <div
                                    class="authentication-level-card__divider"
                                    data-testid="inbox-ui-ticket-header-authentication-request-divider"></div>

                                <div
                                    class="authentication-level-card__section authentication-level-card__section--request"
                                    data-testid="inbox-ui-ticket-header-authentication-request-section">
                                    <h5 data-testid="inbox-ui-ticket-header-authentication-request-label">
                                        {{ 'Authentication request' | translate }}
                                    </h5>
                                    @if (isSessionAuthenticationRequestPending) {
                                        <div
                                            class="authentication-level-card__request-controls"
                                            data-testid="inbox-ui-ticket-header-authentication-request-controls">
                                            <button
                                                type="button"
                                                class="btn btn-sm authentication-level-card__button"
                                                data-testid="inbox-ui-ticket-header-authentication-request-button"
                                                disabled>
                                                {{ 'Request BankID High (10)' | translate }}
                                            </button>
                                            <span
                                                class="authentication-level-card__status"
                                                data-testid="inbox-ui-ticket-header-authentication-request-status">
                                                <span
                                                    class="authentication-level-card__status-label"
                                                    data-testid="inbox-ui-ticket-header-authentication-request-status-label">
                                                    {{ 'Request pending' | translate }}
                                                </span>
                                                <br />
                                                <span
                                                    data-testid="inbox-ui-ticket-header-authentication-request-status-time">
                                                    {{
                                                        ticket.sessionAuthentication.escalationRequestTime
                                                            | date: 'dd.MM.yyyy HH:mm'
                                                    }}
                                                </span>
                                            </span>
                                        </div>
                                    } @else if (isSessionAuthenticationRequestButtonVisible) {
                                        <button
                                            type="button"
                                            class="btn btn-sm authentication-level-card__button"
                                            data-testid="inbox-ui-ticket-header-authentication-request-button"
                                            [disabled]="isSessionAuthenticationRequestButtonDisabled"
                                            (click)="requestSessionAuthentication()">
                                            {{ 'Request BankID High (10)' | translate }}
                                        </button>
                                    }
                                </div>
                            }
                        </section>
                    }
                    @if (!commonDataService.user.isReadOnly) {
                        <div appStickyHeader id="ticket-short-header" class="full-width">
                            <div class="flex-row d-flex justify-content-between flex-wrap">
                                <app-assign-block
                                    (assignTicket)="assignTicket($event)"
                                    [assignee]="ticket.assignee"
                                    [isAssigned]="ticket.isAssigned"
                                    [usersForAssign]="assignService.usersForAssign">
                                </app-assign-block>

                                <div class="flex-row d-flex justify-content-between flex-grow-1">
                                    <app-ticket-toolbar
                                        [ticket]="ticket"
                                        [isSocialMediaTicket]="isSocialMediaTicket"
                                        [ticketViewType]="ticketViewType"
                                        [isCustomerOnline]="isCustomerOnline"
                                        [isUpdatingSpam]="isUpdatingSpam"
                                        (markTicketAsSpam)="markTicketAsSpam()"
                                        (showFullReplyFormEvent)="showFullReplyForm()">
                                    </app-ticket-toolbar>
                                    <div class="btn-group btn-group-sm">
                                        <button
                                            type="button"
                                            class="btn"
                                            data-testid="inbox-ui-ticket-header-open-action"
                                            [ngClass]="{
                                                'btn-default': ticket.status !== ticketStatusEnum.open,
                                                'btn-active': ticket.status === ticketStatusEnum.open,
                                            }"
                                            (click)="updateStatus(ticketStatusEnum.open)"
                                            [disabled]="isStatusUpdating || ticket.isAssignedToBot">
                                            {{ 'Open' | translate }}
                                        </button>
                                        @if (isTicketHeaderVisible('setTicketToPendingAction')) {
                                            <button
                                                type="button"
                                                class="btn"
                                                data-testid="inbox-ui-ticket-header-pending-action"
                                                [ngClass]="{
                                                    'btn-default': ticket.status !== ticketStatusEnum.pending,
                                                    'btn-active': ticket.status === ticketStatusEnum.pending,
                                                }"
                                                (click)="updateStatus(ticketStatusEnum.pending)"
                                                [disabled]="isStatusUpdating || ticket.isAssignedToBot">
                                                {{ 'Pending' | translate }}
                                            </button>
                                        }
                                        <button
                                            type="button"
                                            class="btn"
                                            data-testid="inbox-ui-ticket-header-closed-action"
                                            [ngClass]="{
                                                'btn-default': ticket.status !== ticketStatusEnum.completed,
                                                'btn-active': ticket.status === ticketStatusEnum.completed,
                                            }"
                                            (click)="updateStatus(ticketStatusEnum.completed)"
                                            [disabled]="isStatusUpdating || ticket.isAssignedToBot">
                                            {{ 'Closed' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            @if (loaded && ticketViewType === ticketViewEnum.socialMedia) {
                                <hr />
                                <app-thread-filter id="thread-filters" [ticket]="ticket"></app-thread-filter>
                            }
                        </div>
                    }
                </div>

                @if (loaded && !commonDataService.user.isReadOnly) {
                    <app-ticket-alerts
                        [ticket]="ticket"
                        [assigneeId]="ticket.assignee?.id"
                        [isSocialMediaTicket]="isSocialMediaTicket"
                        [isCustomerOnline]="isCustomerOnline"
                        [ticketStatus]="ticket.status"
                        [ticketUpdateStamp]="ticketUpdateStamp"
                        (assignTicketFromAlert)="assignTicket($event)"
                        (restoreTicketFromAlert)="restore()">
                    </app-ticket-alerts>
                }

                <div
                    id="thread-container-replies"
                    [ngClass]="{ 'thread-container-replies-printing': threadFilterService.isPrinting }">
                    @if (!isTicketReady) {
                        <sb-loader style="z-index: 3"></sb-loader>
                        <div class="ticket-blocker" style="z-index: 2"></div>
                    }

                    @if (noteService.isEditorForNewNoteShown) {
                        <app-reply-note [ticket]="ticket" />
                    }

                    @if (loaded) {
                        @switch (ticketViewType) {
                            @case (ticketViewEnum.formEmailApi) {
                                <app-ticket-thread-web />
                            }

                            @case (ticketViewEnum.chat) {
                                <div class="ticket-block" id="chat-thread-container">
                                    <app-ticket-thread-chat />
                                </div>
                            }

                            @default {
                                <app-ticket-thread-social-media />
                            }
                        }
                    }
                </div>
                @if (
                    threadFilterService.isPrinting &&
                    ticket.notes.length &&
                    isInboxElementVisible(
                        commonDataService.customerSettings?.inboxElementsVisibility?.rightPanel?.notes
                    )
                ) {
                    <div class="notes-for-printing ticket-block ticket-thread-for-printing" style="display: none">
                        <h4 class="text-center">Notes</h4>
                        <app-ticket-notes [ticket]="ticket" [isForPrinting]="true" style="height: auto" />
                    </div>
                }
            </div>
            @if (ticket.selectedRepliesCount() > 0) {
                <app-replies-bulk-operation-menu [ticket]="ticket" />
            }
        </div>
    </div>

    @if (isTicketRightPanelVisible()) {
        <div id="ticket-right-panel" class="print-hidden">
            <app-ticket-right-panel
                style="float: right; height: 100%; display: block"
                class="right-panel"
                [ticket]="ticket"
                [isLoading]="!loaded">
            </app-ticket-right-panel>
        </div>
    }
</div>
